import { useTranslation } from 'react-i18next';
import { Button } from '@innovationnorway/cl-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export function FormStepButtons({
  stepBackward,
  isLoading,
  stepForward,
  stepForwardDisabled,
}: {
  isLoading?: boolean | undefined;
  stepForward?: (() => void) | undefined;
  stepBackward?: (() => void) | undefined;
  stepForwardDisabled?: boolean;
}) {
  const { t } = useTranslation();
  const { t: tSiva } = useTranslation('siva');
  const navigate = useNavigate();
  return (
    <div className="display--flex align-items--center gap--1 margin-y--3">
      {stepBackward && (
        <Button type="button" variant="secondary" onClick={stepBackward} loading={isLoading}>
          {t('previous')}
        </Button>
      )}
      {stepForward ? (
        <Button
          type="button"
          variant="primary"
          onClick={stepForward}
          loading={isLoading}
          disabled={stepForwardDisabled}
        >
          {t('next')}
        </Button>
      ) : (
        <Button type="submit" variant="primary" loading={isLoading}>
          {tSiva('newCompany.buttons.complete')}
        </Button>
      )}
      <Button type="button" variant="tertiary" onClick={() => navigate('..')} disabled={isLoading}>
        {t('cancel')}
      </Button>
    </div>
  );
}
